export const playlist = [
  'track1.mp3',
  'track2.mp3',
  'track3.mp3',
  'track4.mp3',
  'track5.mp3',
  'track6.mp3',
  'track7.mp3',
  'track8.mp3',
  'track9.mp3',
  'track10.mp3',
  'track11.mp3'
];